/**
 * Semantic Heroicons mapping for navigation and UI.
 * Reuses @heroicons/react only — no new icon libraries.
 */
import {
    HomeIcon,
    UserCircleIcon,
    MapIcon,
    ClockIcon,
    BookOpenIcon,
    ClipboardDocumentListIcon,
    BuildingOffice2Icon,
    FolderIcon,
    AcademicCapIcon,
    UserGroupIcon,
    SparklesIcon,
    BriefcaseIcon,
    DocumentCheckIcon,
    TrophyIcon,
    BellIcon,
    LifebuoyIcon,
    ChartBarIcon,
    Cog6ToothIcon,
    UsersIcon,
    UserPlusIcon,
    RectangleStackIcon,
    QuestionMarkCircleIcon,
    CheckCircleIcon,
    XCircleIcon,
    ExclamationTriangleIcon,
    LockClosedIcon,
    ArrowRightOnRectangleIcon,
    Bars3Icon,
    XMarkIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    ChevronDownIcon,
    MagnifyingGlassIcon,
    PlusIcon,
    PencilSquareIcon,
    TrashIcon,
    ArrowDownTrayIcon,
    ArrowUpTrayIcon,
    PaperAirplaneIcon,
    IdentificationIcon,
    PuzzlePieceIcon,
    ClipboardDocumentCheckIcon,
} from '@heroicons/react/24/outline';

export const NAV_ICONS = {
    '/dashboard': HomeIcon,
    '/admin/dashboard': HomeIcon,
    '/mentor/dashboard': HomeIcon,
    '/profile': UserCircleIcon,
    '/journey': MapIcon,
    '/hours': ClockIcon,
    '/admin/hours': ClockIcon,
    '/learning': BookOpenIcon,
    '/tasks': ClipboardDocumentListIcon,
    '/practical-challenges': PuzzlePieceIcon,
    '/admin/practical-challenges': PuzzlePieceIcon,
    '/admin/career-directions': BriefcaseIcon,
    '/mentor/practical-challenges': PuzzlePieceIcon,
    '/mentor/challenge-reviews': ClipboardDocumentCheckIcon,
    '/business': BuildingOffice2Icon,
    '/projects': FolderIcon,
    '/skills': AcademicCapIcon,
    '/my-mentor': UserGroupIcon,
    '/mentor/interns': UsersIcon,
    '/ai-coach': SparklesIcon,
    '/professional-journey': BriefcaseIcon,
    '/evidence': DocumentCheckIcon,
    '/completion': TrophyIcon,
    '/notifications': BellIcon,
    '/help': LifebuoyIcon,
    '/admin/reports': ChartBarIcon,
    '/reports': ChartBarIcon,
    '/admin/interns': UsersIcon,
    '/admin/user-info': IdentificationIcon,
    '/admin/onboarding': UserCircleIcon,
    '/onboarding': UserCircleIcon,
    '/admin/cohorts': RectangleStackIcon,
    '/admin/staff': UserPlusIcon,
    '/admin/support': LifebuoyIcon,
    '/admin/settings': Cog6ToothIcon,
    '/solutions': SparklesIcon,
    '/pilots': FolderIcon,
};

export function getNavIcon(href) {
    if (NAV_ICONS[href]) return NAV_ICONS[href];
    // prefix match for nested routes
    const key = Object.keys(NAV_ICONS).find((k) => href.startsWith(k) && k !== '/');
    return key ? NAV_ICONS[key] : QuestionMarkCircleIcon;
}

export const UI_ICONS = {
    home: HomeIcon,
    user: UserCircleIcon,
    clock: ClockIcon,
    book: BookOpenIcon,
    building: BuildingOffice2Icon,
    folder: FolderIcon,
    sparkles: SparklesIcon,
    briefcase: BriefcaseIcon,
    trophy: TrophyIcon,
    bell: BellIcon,
    help: LifebuoyIcon,
    chart: ChartBarIcon,
    settings: Cog6ToothIcon,
    users: UsersIcon,
    check: CheckCircleIcon,
    x: XCircleIcon,
    warning: ExclamationTriangleIcon,
    lock: LockClosedIcon,
    logout: ArrowRightOnRectangleIcon,
    menu: Bars3Icon,
    close: XMarkIcon,
    chevronLeft: ChevronLeftIcon,
    chevronRight: ChevronRightIcon,
    chevronDown: ChevronDownIcon,
    search: MagnifyingGlassIcon,
    plus: PlusIcon,
    edit: PencilSquareIcon,
    trash: TrashIcon,
    download: ArrowDownTrayIcon,
    upload: ArrowUpTrayIcon,
    send: PaperAirplaneIcon,
    map: MapIcon,
};

export const ROLE_LABELS = {
    intern: 'Intern',
    mentor: 'Mentor',
    admin: 'Program Admin',
};
